module.exports = __webpack_public_path__ + "static/media/away.f1c18eb5.svg";